import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { DataService } from '../shared/network/data.service';
import { ProjectService } from '../shared/project/project.service';

@Component({
    selector: 'main-menu',
    templateUrl: './main-menu.component.html',
})
export class MainMenuComponent implements OnInit {
    public showMenu: boolean = false;
    public showCacheClearBtn = false;
    public logoutUrl: string;
    @ViewChild('btnShowMenu') btnShowMenu: ElementRef;
    @ViewChild('menu') menu: ElementRef;

    constructor(private dataService: DataService, private projectService: ProjectService) {}

    ngOnInit(): void {
        this.showCacheClearBtn = window.location.host.indexOf('localhost') >= 0;
        this.logoutUrl = this.dataService.getBaseUrl() + '/account/logout';
    }

    public async clearCacheAndReload() {
        await this.dataService.post('processing/clearCache', {
            projectId: this.projectService.getProjectId(),
        });
        window.location.reload();
    }
}
